import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { SecretaryAreaFull } from '@/features/secretary/SecretaryAreaFull';
import { MobileSecretaryArea } from '@/features/secretary/mobile/MobileSecretaryArea';

export const Route = createFileRoute('/_app/secretary/area')({
  component: SecretaryAreaRoute,
});

/** Selettore: area segreteria mobile (MaeDesign) vs hub desktop a tabelle. */
function SecretaryAreaRoute() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileSecretaryArea /> : <SecretaryAreaFull />;
}
